export default __webpack_public_path__ + "static/media/soc-fm.3702bab5.mp4";